const ColorMap = {
    "purple": 0x800080,
    "orange": 0xffa500,
    "white": 0xFFFFFF,
    "red": 0xFF0000,
    "green": 0x00FF00,
    "blue": 0x0000FF,
    "black": 0x000000,
    "yellow": 0xFFFF00,
    "gray": 0x808080
};
export class Color {
    static hexToString(color) {
        tmpColor.parse(color);
        return tmpColor.toString();
    }
    static stringToHex(value) {
        tmpColor.parse(value);
        return tmpColor.getRGB();
    }
    static gammaToLinearSpace(value) {
        if (value <= 0.04045)
            return value / 12.92;
        else if (value < 1.0)
            return Math.pow((value + 0.055) / 1.055, 2.4);
        else
            return Math.pow(value, 2.4);
    }
    static linearToGammaSpace(value) {
        if (value <= 0.0)
            return 0.0;
        else if (value <= 0.0031308)
            return 12.92 * value;
        else if (value <= 1.0)
            return 1.055 * Math.pow(value, 0.41666) - 0.055;
        else
            return Math.pow(value, 0.41666);
    }
    constructor(r = 1, g = 1, b = 1, a = 1) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    equal(c) {
        if (!c)
            return false;
        const toFIxed = (a, b) => {
            var delta = 1e-5;
            return -delta < a - b && a - b < delta;
        };
        return toFIxed(c.r, this.r) && toFIxed(c.g, this.g) && toFIxed(c.b, this.b) && toFIxed(c.a, this.a);
    }
    parse(value) {
        if (value == null)
            value = 0;
        if (typeof value === 'number') {
            if (value < 0 || isNaN(value))
                value = 0;
            this.setRGB(value);
        }
        else if (value.indexOf("rgba(") >= 0 || value.indexOf("rgb(") >= 0) {
            let p1 = value.indexOf("(");
            let p2 = value.indexOf(")");
            if (p1 == -1 || p2 == -1) {
                this.setValue(0, 0, 0, 1);
                return this;
            }
            value = value.substring(p1 + 1, p2);
            let arr = value.split(",");
            let len = arr.length;
            for (let i = 0; i < len; i++) {
                arr[i] = parseFloat(arr[i]);
                if (isNaN(arr[i]))
                    arr[i] = 0;
            }
            this.r = arr[0] / 255;
            this.g = arr[1] / 255;
            this.b = arr[2] / 255;
            if (arr.length == 4)
                this.a = arr[3];
            else
                this.a = 1;
        }
        else {
            if (value.charAt(0) === '#')
                value = value.substring(1);
            else {
                let rgb = ColorMap[value];
                if (rgb) {
                    this.setRGB(rgb);
                    return this;
                }
            }
            let len = value.length;
            if (len === 3 || len === 4) {
                let temp = "";
                for (let i = 0; i < len; i++) {
                    temp += (value[i] + value[i]);
                }
                value = temp;
            }
            let rgb;
            let a = 1;
            if (len == 8) {
                rgb = parseInt(value.substring(0, 6), 16);
                a = parseInt(value.substring(6, 8), 16) / 255;
            }
            else {
                rgb = parseInt(value, 16);
                a = 1;
            }
            this.setRGB(rgb);
            this.a = a;
        }
        return this;
    }
    toLinear(out) {
        out.r = Color.gammaToLinearSpace(this.r);
        out.g = Color.gammaToLinearSpace(this.g);
        out.b = Color.gammaToLinearSpace(this.b);
        out.a = this.a;
    }
    toGamma(out) {
        out.r = Color.linearToGammaSpace(this.r);
        out.g = Color.linearToGammaSpace(this.g);
        out.b = Color.linearToGammaSpace(this.b);
        out.a = this.a;
    }
    cloneTo(destObject) {
        destObject.r = this.r;
        destObject.g = this.g;
        destObject.b = this.b;
        destObject.a = this.a;
    }
    scale(value) {
        this.r = this.r * value;
        this.g = this.g * value;
        this.b = this.b * value;
        return this;
    }
    setValue(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset + 0];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        this.a = array[offset + 3];
    }
    toArray() {
        return [this.r, this.g, this.b, this.a];
    }
    writeTo(arr, offset = 0) {
        arr[offset + 0] = this.r;
        arr[offset + 1] = this.g;
        arr[offset + 2] = this.b;
        arr[offset + 3] = this.a;
    }
    clone() {
        var dest = new Color();
        this.cloneTo(dest);
        return dest;
    }
    getRGB() {
        return (Math.round(this.r * 255) << 16) + (Math.round(this.g * 255) << 8) + Math.round(this.b * 255);
    }
    setRGB(value) {
        this.r = ((value >> 16) & 0xFF) / 255;
        this.g = ((value >> 8) & 0xFF) / 255;
        this.b = (value & 0xFF) / 255;
        this.a = 1;
    }
    getARGB() {
        return (Math.round(this.a * 255) << 24) + (Math.round(this.r * 255) << 16) + (Math.round(this.g * 255) << 8) + Math.round(this.b * 255);
    }
    getABGR() {
        return (Math.round(this.a * 255) << 24) + (Math.round(this.b * 255) << 16) + (Math.round(this.g * 255) << 8) + Math.round(this.r * 255);
    }
    setABGR(value) {
        this.a = ((value >> 24) & 0xFF) / 255;
        this.b = ((value >> 16) & 0xFF) / 255;
        this.g = ((value >> 8) & 0xFF) / 255;
        this.r = (value & 0xFF) / 255;
    }
    toString() {
        let str = this.getRGB().toString(16);
        while (str.length < 6)
            str = "0" + str;
        return "#" + str;
    }
    getStyleString() {
        if (this.a == 1)
            return this.toString();
        else
            return "rgba(" + Math.round(this.r * 255) + "," + Math.round(this.g * 255) + "," + Math.round(this.b * 255) + "," + this.a + ")";
    }
}
Color.RED = new Color(1, 0, 0, 1);
Color.GREEN = new Color(0, 1, 0, 1);
Color.BLUE = new Color(0, 0, 1, 1);
Color.CYAN = new Color(0, 1, 1, 1);
Color.YELLOW = new Color(1, 0.92, 0.016, 1);
Color.MAGENTA = new Color(1, 0, 1, 1);
Color.GRAY = new Color(0.5, 0.5, 0.5, 1);
Color.WHITE = new Color(1, 1, 1, 1);
Color.BLACK = new Color(0, 0, 0, 1);
Color.CLEAR = new Color(0, 0, 0, 0);
const tmpColor = new Color();
